<template>
  <section class="container">
    <section class="title_box">
      <img src="@/assets/images/act_success.png" />
      <p>预订成功！</p>
    </section>
    <p class="desc">已成功预订会议室，欢迎您的到来~</p>
    <p class="back_btn">
        <span class="btn_left" @click="backFun">返回</span>
        <span class="btn_right">查看订单</span>
    </p>
  </section>
</template>

<script>
export default {
  props:{
    come:{
      type:String,
      default:''
    }
  },
  data () {
    return {
      title:'发送成功',
      desc:'已成功发送至电子邮箱，请注意查收~'
    }
  },
  created () {
    document.title = this.$route.query.title || '';
    this.title = this.$route.query.title || '';
    this.desc = this.$route.query.desc || '';
  },
  methods: {
    backFun(){
      if(this.come === 'parkingCoupon'){
        this.$store.commit('isChange', true);
        this.$router.go(-2)
      }else{
        this.$router.go(-1)
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container{
  background:#fff;
}
.title_box{
  .flex();
  justify-content:center;
  align-items:center;
  margin:120px 0 28px;
  img{
    width:44px;
    height:44px;
    margin-right:14px;
  }
  p{
    font-size:48px;
    color:#333;
    line-height:66px;
  }
}
.desc{
  text-align:center;
  font-size:28px;
  color:rgba(153,153,153,1);
  line-height:40px;
  margin-bottom:114px;
}
.back_btn{
    .flex();
    padding:0 30px;
    justify-content: space-between;
    .btn_left{
        width:332px;
        height:88px;
        border-radius:8px;
        border:2px solid rgba(23,64,218,1);
        box-sizing:border-box;
        text-align: center;
        line-height: 88px;
        font-size:32px;
        color:rgba(23,64,218,1);
    }
    .btn_right{
        width:332px;
        height:88px;
        background:rgba(23,64,218,1);
        border-radius:8px;
        text-align:center;
        line-height:88px;
        font-size:32px;
        color:rgba(255,255,255,1);
    }
}
</style>
